// Usage Level Selector - Low/Moderate/Heavy buttons for electricity usage

import type { UsageLevel } from '@/utils/planCalculations';

interface UsageLevelSelectorProps {
  value: UsageLevel;
  onChange: (level: UsageLevel) => void;
  disabled?: boolean;
}

export function UsageLevelSelector({ value, onChange, disabled }: UsageLevelSelectorProps) {
  const levels: { key: UsageLevel; label: string }[] = [
    { key: 'low', label: 'Low' },
    { key: 'moderate', label: 'Moderate' },
    { key: 'heavy', label: 'Heavy' },
  ];

  return (
    <div className="usage-level-selector">
      {levels.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`usage-level-btn ${value === key ? 'usage-level-btn--active' : ''}`}
          onClick={() => onChange(key)}
          disabled={disabled}
          data-level={key}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
